import JustValidate from "./../../node_modules/just-validate";
import { populateCountryData } from "./form-countryCodes";

let loader = document.querySelector(".loader");

document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("chargeonpop");
  const overlay = document.querySelector(".modal-overlay");
  const formSection = document.querySelector("#chargeonpop .container");
  const iframeSection = document.querySelector("#chargeonpop .iframeshow");

  populateCountryData();

  const allTextIds = [
    "easyway",
    "freeTrialNow",
    "requestdemohNew",
    "paySmarter",
    "blogContactPopup",
  ];
  const mainImage = document.getElementById("formMainImage");
  const blogImage = document.getElementById("imageBlogSection");

  function openChargeOnModal(event) {
    event.preventDefault();
    const clickedBtn = event.currentTarget;

    allTextIds.forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.style.display = "none";
    });

    if (clickedBtn.classList.contains("getstarted")) {
      showElement("easyway");
      showView("form");
    } else if (clickedBtn.classList.contains("iamready")) {
      showElement("paySmarter");
      showView("form");
    } else if (clickedBtn.classList.contains("blogContactPopup")) {
      showElement("blogContactPopup");
      showView("form");
      if (mainImage) mainImage.style.display = "none";
      if (blogImage) blogImage.style.display = "block";
    } else if (
      clickedBtn.classList.contains("bookdemo") ||
      clickedBtn.classList.contains("requestademoChargeonBooking")
    ) {
      showElement("requestdemohNew");
      showView("iframe");
    } else {
      showElement("easyway");
      showView("form");
    }
    modal.style.display = "block";
    overlay.style.display = "block";
    setTimeout(() => {
      modal.classList.add("open");
      overlay.classList.add("open");
    }, 10);
  }

  function showElement(id) {
    const el = document.getElementById(id);
    if (el) el.style.display = "block";
  }

  function showView(type) {
    if (type === "form") {
      formSection.style.display = "block";
      iframeSection.style.display = "none";
    } else {
      formSection.style.display = "none";
      iframeSection.style.display = "block";
    }
  }

  function closeModal() {
    document.body.style.overflow = "";
    modal.classList.remove("open");
    overlay.classList.remove("open");
    setTimeout(() => {
      modal.style.display = "none";
      overlay.style.display = "none";
      const iframe = iframeSection.querySelector("iframe");
      if (iframe) iframe.src = iframe.src;
      if (mainImage) mainImage.style.display = "block";
      if (blogImage) blogImage.style.display = "none";
    }, 300);
  }

  const triggerSelector =
    ".getstarted, .iamready, .blogContactPopup, .bookdemo, .requestademoChargeonBooking, .modal-trigger";
  document.querySelectorAll(triggerSelector).forEach((btn) => {
    btn.addEventListener("click", openChargeOnModal);
  });

  document.querySelectorAll('a[href="#chargeOnPopupForm"]').forEach((btn) => {
    btn.addEventListener("click", openChargeOnModal);
  });

  // Close triggers
  document
    .querySelectorAll(".modal-close, .l-modal__bt-close")
    .forEach((btn) => {
      btn.addEventListener("click", closeModal);
    });
  overlay.addEventListener("click", closeModal);

  window.addEventListener("keyup", (e) => {
    if (e.key === "Escape") closeModal();
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const generalPopup = document.getElementById("popup");
  const bookCallButtons = document.querySelectorAll(".bookacall");
  const generalCloseButtons = document.querySelectorAll(
    ".popup .closediv, .popup .closediv svg",
  );
  const popupForm = document.querySelector("#popup-form-demo");
  bookCallButtons.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      if (generalPopup) {
        generalPopup.style.display = "block";
      }
    });
  });

  const closeGeneralPopup = () => {
    if (generalPopup) {
      generalPopup.style.display = "none";
    }
    if (popupForm) {
      popupForm.reset();
      demoFormPopup.refresh();
    }
  };

  generalCloseButtons.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      closeGeneralPopup();
    });
  });

  window.addEventListener("click", function (e) {
    if (e.target === generalPopup) {
      closeGeneralPopup();
    }
  });

  window.addEventListener("keyup", (e) => {
    if (e.key === "Escape") {
      closeGeneralPopup();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var url = window.location.href;

  const scrollToContact = () => {
    const contactSection = document.querySelector(
      'section[data-id="ContactUs"]',
    );
    if (contactSection) {
      const top =
        contactSection.getBoundingClientRect().top + window.pageYOffset + 1000;
      window.scrollTo({ top: top, behavior: "smooth" });
    }
  };

  if (url.indexOf("#ContactUs") > 0) {
    setTimeout(scrollToContact, 500);
  }

  document.querySelectorAll(".ContactUs").forEach((el) => {
    el.addEventListener("click", scrollToContact);
  });

  // Header and Dropdowns
  document
    .querySelectorAll(".head-bar-list, .product-bar-list")
    .forEach((el) => (el.style.display = "none"));

  const headBar = document.querySelector(".head-bar");
  if (headBar) {
    headBar.addEventListener("click", function () {
      const list = document.querySelector(".head-bar-list");
      if (list)
        list.style.display = list.style.display === "none" ? "" : "none";
    });
  }

  document.querySelectorAll(".our-products").forEach((el) => {
    el.addEventListener("click", function () {
      const list = this.parentElement.querySelector(".product-bar-list");

      if (!list) return;

      if (getComputedStyle(list).display === "none") {
        list.style.display = list.classList.contains("dual-column")
          ? "grid"
          : "block";
      } else {
        list.style.display = "none";
      }
    });
  });
});

let GoogleSendURL =
  "https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec";

// #region Footer Subscribe Form
const validate = new JustValidate("#footer-subscribe");
validate
  .addField("#footer-subscribe-fullname", [
    {
      rule: "required",
    },
    {
      rule: "customRegexp",
      value: /^[a-zA-Z]+ [a-zA-Z]+$/,
      errorMessage: "Please enter a Full Name",
    },
  ])
  .addField("#footer-subscribe-companyemail", [
    {
      rule: "required",
    },
    {
      rule: "email",
    },
    {
      validator: (value) => {
        let emailRegex =
          /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
        return emailRegex.test(value);
      },
      errorMessage: "Please Enter Valid Email Address",
    },
  ]);

document
  .querySelector("#footer-subscribe")
  .addEventListener("submit", async (event) => {
    event.preventDefault();
    if (validate.isValid == false) {
      return false;
    }
    loader.classList.add("active");

    let formData = new FormData(event.target);
    let fullName = formData.get("lfirstname").split(" ");
    let firstName, lastName;
    [firstName, ...lastName] = fullName;
    lastName = lastName.join(" ");
    formData.set("lfirstname", firstName);
    formData.set("llastname", lastName);
    formData.append("sendurlvalue", window.location.href);
    formData.append("lsource", "ChargeOn-NewsLetter-Footer");

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    // Initiate the Sales IQ visitor data
    if (window.$zoho && window.$zoho.salesiq) {
      try {
        $zoho.salesiq.visitor.uniqueid();
        $zoho.salesiq.visitor.name(firstName + " " + lastName);
        $zoho.salesiq.visitor.email(formData.get("lemail"));
        console.log("SalesIQ Name/Email set");
      } catch (error) {
        console.warn("SalesIQ Error:", error);
      }
    }

    let raw = JSON.stringify({
      firstName: formData.get("lfirstname"),
      lastName: formData.get("llastname"),
      email: formData.get("lemail"),
      leadSource: formData.get("lsource"),
      websiteVisitURL: window.location.href,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    let googleRequestOptions = {
      method: "GET",
      redirect: "follow",
    };
    let request = "?";
    [...formData].forEach(([key, value], index) => {
      request += `${index === 0 ? "" : "&"}${key + "=" + value}`;
    });

    // Request 1: Main Backend
    const backendRequest = fetch(
      "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
      requestOptions,
    );

    // Request 2: Update the Google Sheet Data
    const googleRequest = fetch(GoogleSendURL + request, googleRequestOptions);

    // Waiting until these request get's completed
    try {
      await Promise.allSettled([backendRequest, googleRequest]);
    } catch (e) {
      console.error("API Error", e);
    }

    // Redirect
    window.location.href = "https://products.cyntexa.com/success";
  });
// #endregion Footer Subscribe Form

// #region DEMO FORM POPUP
const demoFormPopup = new JustValidate("#popup-form-demo");
demoFormPopup
  .addField("#demo-form-fullname", [
    {
      rule: "required",
    },
    {
      rule: "customRegexp",
      value: /^[a-zA-Z]+ [a-zA-Z]+$/,
    },
  ])
  .addField("#demo-form-email", [
    {
      rule: "required",
    },
    {
      rule: "email",
    },
    {
      validator: (value) => {
        let emailRegex =
          /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
        return emailRegex.test(value);
      },
      errorMessage: "Please Enter Valid Email Address",
    },
  ])
  .addField("#demo-form-phoneCode", [
    {
      rule: "required",
      // errorMessage: "The field is required",
    },
    {
      validator: (value) => {
        return value != "none" && value !== null;
      },
      errorMessage: "The field is required",
    },
  ])
  .addField("#demo-form-phone", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 4,
    },
    {
      rule: "customRegexp",
      value: /^[0-9]+$/,
    },
    {
      rule: "maxLength",
      value: 15,
    },
    {
      rule: "number",
    },
  ])
  .addField("#demo-form-company", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
  ])
  .addField("#demo-form-country", [
    {
      rule: "required",
      errorMessage: "The field is required",
    },
    {
      validator: (value) => {
        return value != "none" && value !== null;
      },
      errorMessage: "The field is required",
    },
  ])
  .addField("#demo-form-jobrole", [
    {
      rule: "required",
    },
    {
      validator: (value) => {
        return value != "none" && value !== null;
      },
      errorMessage: "The field is required",
    },
  ])
  .addField("#demo-form-description", [
    {
      rule: "required",
    },
  ]);

document
  .querySelector("#popup-form-demo")
  .addEventListener("submit", async (event) => {
    event.preventDefault();
    if (demoFormPopup.isValid == false) {
      return false;
    }

    loader.classList.add("active");

    let formData = new FormData(event.target);
    let fullName = formData.get("lfirstname").split(" ");
    let firstName, lastName;
    [firstName, ...lastName] = fullName;
    lastName = lastName.join(" ");
    let phoneNumber = formData.get("lphone");
    formData.set("lfirstname", firstName);
    formData.set("llastname", lastName);
    formData.set("lphone", phoneNumber);
    formData.append("sendurlvalue", window.location.href);
    let lSource = "ChargeOn - Interested";
    const url = window.location.href;

    const sourceMap = {
      chargeon: "product-website-chargeon",
      aarchmerchanttool: "product-website-aarch-merchant-tool",
      easyrollup: "product-website-easy-rollup",
      easyincentivizer: "product-website-easy-incentivizer",
    };

    for (const [key, value] of Object.entries(sourceMap)) {
      if (url.includes(key)) {
        lSource = value;
        break;
      }
    }
    formData.append("lsource", lSource);

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    // Initiate the Sales IQ visitor data
    if (window.$zoho && window.$zoho.salesiq) {
      try {
        $zoho.salesiq.visitor.uniqueid();
        $zoho.salesiq.visitor.name(firstName + " " + lastName);
        $zoho.salesiq.visitor.email(formData.get("lemail"));
        console.log("SalesIQ Name/Email set");
      } catch (error) {
        console.warn("SalesIQ Error:", error);
      }
    }

    let raw = JSON.stringify({
      firstName: formData.get("lfirstname"),
      lastName: formData.get("llastname"),
      email: formData.get("lemail"),
      phone: formData.get("phonecode") + " " + formData.get("lphone"),
      company: formData.get("lcompany"),
      country: formData.get("lcountry"),
      jobTitle: formData.get("ljobtitle"),
      description: formData.get("Description"),
      leadSource: formData.get("lsource"),
      websiteVisitURL: window.location.href,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    let googleRequestOptions = {
      method: "GET",
      redirect: "follow",
    };
    let request = "?";
    [...formData].forEach(([key, value], index) => {
      request += `${index === 0 ? "" : "&"}${key + "=" + value}`;
    });

    // Request 1: Main Backend
    const backendRequest = fetch(
      "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
      requestOptions,
    );

    // Request 2: Update the Google Sheet Data
    const googleRequest = fetch(GoogleSendURL + request, googleRequestOptions);

    // Waiting until these request get's completed
    try {
      await Promise.allSettled([backendRequest, googleRequest]);
    } catch (e) {
      console.error("API Error", e);
    }

    // Redirect
    window.location.href = "https://products.cyntexa.com/success";
  });
// #endregion DEMO FORM POPUP

// #region We are Just A Message Away - Form
const chargeOnPopupForm = new JustValidate("#make-payment-form");
chargeOnPopupForm
  .addField("#make-payment-form-name", [
    {
      rule: "required",
    },
    {
      rule: "customRegexp",
      value: /^[a-zA-Z]+ [a-zA-Z]+$/,
    },
  ])
  .addField("#make-payment-form-company", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
  ])
  .addField("#make-payment-form-email", [
    {
      rule: "required",
    },
    {
      rule: "email",
    },
    {
      validator: (value) => {
        let emailRegex =
          /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
        return emailRegex.test(value);
      },
      errorMessage: "Please Enter Valid Email Address",
    },
  ])
  .addField("#make-payment-form-jobtitle", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
  ])
  .addField("#make-payment-form-country", [
    {
      rule: "required",
    },
    {
      validator: (value) => {
        return value !== "none" && value !== null;
      },
      errorMessage: "The field is required",
    },
  ])
  .addField("#make-payment-form-countryCode", [
    {
      rule: "required",
    },
    {
      validator: (value) => {
        return value !== "none" && value !== null;
      },
      errorMessage: "The field is required",
    },
  ])
  .addField("#make-payment-form-phone", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 4,
    },
    {
      rule: "customRegexp",
      value: /^[0-9]+$/,
    },
    {
      rule: "maxLength",
      value: 15,
    },
    {
      rule: "number",
    },
  ])
  .addField("#make-payment-form-message", [
    {
      rule: "required",
    },
  ]);

document
  .querySelector("#make-payment-form")
  .addEventListener("submit", async (event) => {
    event.preventDefault();
    if (chargeOnPopupForm.isValid == false) {
      return false;
    }

    loader.classList.add("active");

    let formData = new FormData(event.target);

    let fullName = formData.get("lfirstname").split(" ");
    let firstName, lastName;
    [firstName, ...lastName] = fullName;
    lastName = lastName.join(" ");
    let phoneNumber = formData.get("lphone");
    formData.set("lfirstname", firstName);
    formData.set("llastname", lastName);
    formData.set("lphone", phoneNumber);
    formData.append("sendurlvalue", window.location.href);
    formData.append("lsource", "ChargeOn - Interested");

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    // Initiate the Sales IQ visitor data
    if (window.$zoho && window.$zoho.salesiq) {
      try {
        $zoho.salesiq.visitor.uniqueid();
        $zoho.salesiq.visitor.name(firstName + " " + lastName);
        $zoho.salesiq.visitor.email(formData.get("lemail"));
        console.log("SalesIQ Name/Email set");
      } catch (error) {
        console.warn("SalesIQ Error:", error);
      }
    }

    let raw = JSON.stringify({
      firstName: formData.get("lfirstname"),
      lastName: formData.get("llastname"),
      company: formData.get("lcompany"),
      email: formData.get("lemail"),
      jobTitle: formData.get("ljobtitle"),
      country: formData.get("lcountry"),
      phone: formData.get("phonecode") + " " + formData.get("lphone"),
      description: formData.get("Description"),
      leadSource: formData.get("lsource"),
      websiteVisitURL: window.location.href,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    let googleRequestOptions = {
      method: "GET",
      redirect: "follow",
    };
    let request = "?";
    [...formData].forEach(([key, value], index) => {
      request += `${index === 0 ? "" : "&"}${key + "=" + value}`;
    });

    // Request 1: Main Backend
    const backendRequest = fetch(
      "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
      requestOptions,
    );

    // Request 2: Update the Google Sheet Data
    const googleRequest = fetch(GoogleSendURL + request, googleRequestOptions);

    // Waiting until these request get's completed
    try {
      await Promise.allSettled([backendRequest, googleRequest]);
    } catch (e) {
      console.error("API Error", e);
    }

    // Redirect
    window.location.href = "https://products.cyntexa.com/success";
  });
// #endregion Global We are Just A Message Away - Form
